import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { GenericDirectivesModule } from '../../generic-directives/generic-directives.module';
import { GenericInputHintModule } from '../../generic-input-hint/generic-input-hint.module';
import { GenericInputSlotModule } from '../../generic-input-slot/generic-input-slot.module';
import { GenericDateInputModule } from '../generic-date-input/generic-date-input.module';
import { GenericMaskInputModule } from '../generic-mask-input/generic-mask-input.module';
import { GenericDateTimeInputComponent } from './generic-date-time-input.component';

export * from './generic-date-time-input.component';

@NgModule({
    declarations: [ GenericDateTimeInputComponent ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        TranslateModule,
        GenericInputHintModule,
        MatInputModule,
        GenericInputSlotModule,
        MatDatepickerModule,
        MatButtonModule,
        MatIconModule,
        GenericMaskInputModule,
        GenericDateInputModule,
        GenericDirectivesModule,
    ],
    exports: [
        GenericDateTimeInputComponent,
    ],
})
export class GenericDateTimeInputModule {
}
